import React, { useContext, useState, useMemo } from 'react';
import { FormCollectionContext } from './FormCollectionContext.js';

const FormCollection = (props)=>{
    const { registerField, unregisterField } = useContext(FormCollectionContext);
    const [fieldList, setFieldList] = useState([]);
    const { children } = props;
    const memo = useMemo(()=>({
            fieldList,
            registerField: (name)=>{
                setFieldList((prev)=>[
                        ...prev,
                        name
                    ]);
                registerField(name);
            },
            unregisterField: (name)=>{
                setFieldList((prev)=>prev.filter((item)=>item !== name));
                unregisterField(name);
            }
        }), [
        fieldList,
        registerField,
        setFieldList,
        unregisterField
    ]);
    return /*#__PURE__*/ React.createElement(FormCollectionContext.Provider, {
        value: memo
    }, children({
        fieldList
    }));
};

export { FormCollection };
//# sourceMappingURL=FormCollection.js.map
